import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { Observable, Subject, BehaviorSubject } from "rxjs";
import { TradeDeal } from "../model/core/TradeDeal";

export const CHANNEL_TRADE_SERVICE: string = "TradeServiceChannel";
export const ENCODABLE_TYPE_ERRORS: string = "com.cubiq.broker.Errors";

export interface ITradeDealService {
  confirmTradeDeal(deal: TradeDeal): Promise<any>;
  confirmTradeDeals(deals: Array<TradeDeal>): Promise<any>;
  cancelTradeDeal(deal: TradeDeal): Promise<any>;
  cancelTradeDeals(deals: Array<TradeDeal>): Promise<any>;
  addFillComment(deal: TradeDeal, comment: string): Promise<any>;
  getTradeDeals(dealIds: Array<string>): Promise<Array<TradeDeal>>;
}
